module.exports = __webpack_public_path__ + "img/6_40.cefa727d.png";